export default __webpack_public_path__ + "static/media/v_wdt_c_2.d9a66823.mp3";